// extracted by mini-css-extract-plugin
module.exports = {"overAll":"candidatedashboardscreen_overAll__l40bb","footerstyle":"candidatedashboardscreen_footerstyle__VZ-ya","pipestyles":"candidatedashboardscreen_pipestyles__b2h2j"};